
import { Component } from 'react'

import { SupportingDocumentationQuestionnaire } from '../../../../../../../lib/Questionnaires'
import {
  YesNoRadioOptions,
  bindTargetMixin,
  CancelButton,
  escapeCancel,
  QuestionRadioButtonInput,
  SaveButton
} from '../../../../../../shared/FormBuilder'
import { Paper } from '../../../../../../shared/NarusMaterial'

import { style } from './style'

class DNR extends bindTargetMixin(Component) {
  constructor (props) {
    super(props)
    this.state = {
      value: { ...props.value }
    }
    this.handleKeyDown = this.handleKeyDown.bind(this)
    this.handleFormSubmit = this.handleFormSubmit.bind(this)
  }

  getValues () {
    return { ...this.state.value }
  }

  handleFormSubmit () {
    const { handleSubmit } = this.props
    handleSubmit(this.getValues())
    this.setState({
      isSubmitting: true
    })
  }

  handleKeyDown (e) {
    escapeCancel(e, this.props.cancel)
  }

  render () {
    const documentation =
      this.state.value.DNRHave === 'yes' && !this.state.value.DNRNarusCopy

    const disableSave = !this.state.value.DNRHave || documentation

    return (

      <form
        onKeyDown={this.handleKeyDown}
        className='margin-top margin-bottom col-xs-12'
      >
        <Paper>
          <h2 className='col-xs-12'> DNR </h2>

          <QuestionRadioButtonInput
            options={YesNoRadioOptions}
            {...SupportingDocumentationQuestionnaire.DNRHave}
            required
          />

          <div
            className='col-xs-12 margin-top'
            style={style.subHead}
          >
            {' '}
            If, yes?
            {' '}
          </div>

          <QuestionRadioButtonInput
            options={YesNoRadioOptions}
            {...SupportingDocumentationQuestionnaire.DNRNarusCopy}
            required={this.state.value.DNRHave === 'yes'}
          />

          <QuestionRadioButtonInput
            options={YesNoRadioOptions}
            {...SupportingDocumentationQuestionnaire.DNRChanges}
          />

          <QuestionRadioButtonInput
            options={YesNoRadioOptions}
            {...SupportingDocumentationQuestionnaire.DNRCopies}
          />

          <QuestionRadioButtonInput
            options={YesNoRadioOptions}
            {...SupportingDocumentationQuestionnaire.DNRQuestions}
          />

          <QuestionRadioButtonInput
            options={YesNoRadioOptions}
            {...SupportingDocumentationQuestionnaire.DNRSendCopies}
          />

          <div
            className='col-xs-12 margin-top'
            style={style.subHead}
          >
            {' '}
            If, no?
            {' '}
          </div>

          <QuestionRadioButtonInput
            options={YesNoRadioOptions}
            {...SupportingDocumentationQuestionnaire.DNRLearning}
          />

          <QuestionRadioButtonInput
            options={YesNoRadioOptions}
            {...SupportingDocumentationQuestionnaire.DNRComplete}
          />

          <div
            className='row margin-top end-xs'
            style={style.marg}
          >
            <div className='col-xs-offset-8 col-xs-4'>
              <CancelButton onClick={this.props.cancel} />
              <SaveButton
                disabled={disableSave || this.state.isSubmitting}
                onClick={this.handleFormSubmit}
              />
            </div>
          </div>
        </Paper>
      </form>
    )
  }
}

export default DNR
